<template>
    <div>

        <!-- Load up the plan details -->
        <PlanDetails v-bind:plan="plan"
                     v-bind:coupon-code="couponCode"
                     v-bind:coupon-valid="couponValid"
                     v-bind:first-cost="firstCost"
                     v-bind:plan-cost="planCost"
                     v-bind:each-billed="eachBilled"
                     v-bind:savings="savings" />

        <div class="coupon-form" v-if="displayCouponForm">
            <!-- Coupon is valid -->
            <div v-if="couponValid" class="success">
                <img src="/images/upgrade/success-circle.png" alt="Success!">
                <h2>SUCCESS!</h2>

                <div v-if="message" class="message">
                    {{this.message}}
                </div>

                <button class="button button-green btn-block" v-if="couponValid && !removeCouponClicked" @click="displayCouponForm = !displayCouponForm">
                    Apply
                </button>
                <button class="button button-red remove btn-block" v-if="couponCode && removeCouponClicked" @click="removeCoupon()">
                    Remove Coupon
                </button>
            </div>

            <!-- Coupon is not valid -->
            <div v-if="couponInvalid" class="error">
                <img src="/images/upgrade/error-circle.png" alt="Error!">

                <h2>{{message}}</h2>
            </div>

            <!-- Coupon has not been applied, show form -->
            <div v-if="!couponApplied">
                <h2  v-if="!couponInvalid">Please Insert Your Coupon Code</h2>

                <div class="form">
                    <div class="form-group">
                        <input type="text" class="form-control" placeholder="Enter Code"
                               v-model="couponCode"
                               v-on:keyup.enter="validateCoupon"
                                maxlength="25">
                    </div>

                    <button class="button button-purple apply" v-if="!invalidPlan" @click="validateCoupon()">APPLY</button>

                    <!-- Shown IF coupon for worng plan -->
                    <button class="button button-green apply btn-block" v-if="invalidPlan" @click="applyDifferentPlan()">
                        <span style="font-size:15px"> Apply Code To {{correctPlan}} Membership</span>
                    </button>
                </div>
            </div>

            <span id="cancelCoupon" v-if="!couponApplied" @click="displayCouponForm = !displayCouponForm">Cancel</span>
        </div>

        <div v-if="showCoupon" class="coupon">
            <a @click="displayCouponForm = !displayCouponForm">
                <span v-if="couponApplied" @click="changeCouponCodeClick()">Change Coupon Code</span>
                <span v-if="!couponApplied">Have a coupon code?</span>
            </a>
        </div>
    </div>
</template>

<script>
import PlanDetails from "./CouponCode/PlanDetails"

export default {
    name: 'CouponForm',
    components: {
        PlanDetails
    },
    props: [
        'plan',
        'planCost',
        'eachBilled',
        'savings',
        'showCoupon'
    ],
    mounted() {},
    data () {
        return {
            isLoading: false,
            displayCouponForm: false,
            couponCode: '', // User's coupon code
            couponValid: false, // If a valid coupon is submitted, set to true
            couponInvalid: false,
            couponApplied: false,
            message: '', // message to show the user for validation
            firstCost: '',
            invalidPlan: false,
            correctPlan: '',
            removeCouponClicked: false,
            planID: ''
        }
    },
    methods: {
        changeCouponCodeClick: function () {
            this.displayCouponForm      = false
            this.removeCouponClicked    = true;
        },
        removeCoupon: function () {
            // TODO Fire off request to kill session
            axios({
                method: 'post',
                url: '/coupon/remove',
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {

                    // Reset the form, the user wants a different coupon
                    this.couponCode             = '';
                    this.couponValid            = false;
                    this.couponInvalid          = false;
                    this.couponApplied          = false;
                    this.removeCouponClicked    = false;
                    this.message                = '';
                    this.firstCost              = '';

                })
                .catch(error => {
                    this.errored = true
                })
        },
        validateCoupon: function () {

            // Let user know we're doing stuff
            this.isLoading = true;

            // Pass in our plan ID for backend validation
            if (this.plan === 'annual') {
                this.planID = 2;
            } else if (this.plan === 'monthly') {
                this.planID = 1;
            } else if (this.plan === 'monthly2') {
                this.planID = 3;
            } else if (this.plan === 'monthly3') {
                this.planID = 4;
            }

            /**
            * Validate our coupon
            * set ourselves a coupon_code session on the backend
             */
            axios({
                method: 'post',
                url: '/coupon/validate',
                data: {
                    coupon_code: this.couponCode,
                    plan: this.plan,
                    plan_id: this.planID
                },
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {

                    if (response.data.success) {

                        // Coupon is valid and has been applied
                        this.couponValid = true;
                        this.couponInvalid = false;
                        this.couponApplied = true;
                        this.message = response.data.message;
                        this.firstCost = response.data.first_cost;

                    } else if (response.data.invalid_plan) {

                        // Coupon has an invalid plan, can be used for dif plan
                        this.invalidPlan    = true;
                        this.correctPlan    = response.data.correct_plan;

                        this.couponInvalid  = true;
                        this.message        = response.data.message;

                    } else {

                        // Coupon is valid and has been applied
                        this.couponInvalid  = true;
                        this.message        = response.data.message
                    }

                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error)
                    this.errored = true
                })
                .finally(() => this.loading = false)
        },
        applyDifferentPlan: function () {

            // We need to apply the coupon to a different plan

            // Pass in our plan ID for backend validation
            if (this.plan === 'annual') {
                this.planID = 2;
            } else if (this.plan === 'monthly') {
                this.planID = 1;
            } else if (this.plan === 'monthly2') {
                this.planID = 3;
            }

            // Let user know we're doing stuff
            this.isLoading = true;

            /**
             * Validate our coupon
             * set ourselves a coupon_code session on the backend
             */
            axios({
                method: 'post',
                url: '/coupon/validate',
                data: {
                    coupon_code: this.couponCode,
                    plan: this.correctPlan,
                    plan_id: this.planID
                },
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {

                    if (response.data.success) {

                        // Coupon is valid and has been applied
                        this.couponValid = true;
                        this.couponInvalid = false;
                        this.couponApplied = true;
                        this.message = response.data.message;
                        this.firstCost = response.data.first_cost;
                    } else if (response.data.invalid_plan) {

                        // Coupon has an invalid plan, can be used for dif plan
                        this.invalidPlan    = true;
                        this.correctPlan    = response.data.correct_plan;

                        this.couponInvalid  = true;
                        this.message        = response.data.message;

                    } else {

                        // Coupon is valid and has been applied
                        this.couponInvalid  = true;
                        this.message        = response.data.message
                    }

                    this.isLoading = false;
                })
                .catch(error => {
                    this.errored = true
                })
                .finally(() => this.loading = false)
        }
    }
}
</script>
